import { FC } from "react";
import DeprecatedTagButton from "../../../components/features/DeprecatedTagButton";
import FileHelper from "../../../helpers/FileHelper";
import styles from "./styles.scss";

interface ImageNamesProps {
  karteImageAttachments?: File[];
  setKarteImageAttachments: (value: File[]) => void;
}

export const handleImageAttachmentDelete =
  (
    karteImageAttachments: File[] | undefined,
    setKarteImageAttachments: (value: File[]) => void,
    index: number,
  ) =>
  () => {
    if (!karteImageAttachments) {
      return;
    }

    const updatedAttachments = [...karteImageAttachments];
    updatedAttachments.splice(index, 1);
    setKarteImageAttachments(updatedAttachments);
  };

export const ImageNames: FC<ImageNamesProps> = ({
  karteImageAttachments,
  setKarteImageAttachments,
}) => {
  if (!karteImageAttachments) {
    return null;
  }

  return (
    <>
      {karteImageAttachments.map((imageAttachment: File, i: number) => (
        <div
          className={styles.filename}
          key={`StudentKarteForm-imageNames-${i}`}
        >
          <DeprecatedTagButton
            label={FileHelper.truncateFilename(imageAttachment.name, 30)}
            iconName="icon-close-x"
            theme="lightgray"
            onClick={handleImageAttachmentDelete(
              karteImageAttachments,
              setKarteImageAttachments,
              i,
            )}
          />
        </div>
      ))}
    </>
  );
};

export default ImageNames;
